import { StdResponse, bimAxios, manageAxios } from "@/config/axios";

export function checkFileExists(md5: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/files/md5/${md5}`, {
        params: params,
    })
}

export function getFileUploadUrl(objectName: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/objects/upload/url`, {
        params: {
            objectName: `${objectName}`,
            ...params,
        }
    })
}

export function checkManageFileExists(md5: string, params?: {}): Promise<StdResponse<any>> {
    return manageAxios.get(`/files/md5/${md5}`, {
        params: params,
    })
}

export function getManageFileUploadUrl(objectName: string, params?: {}): Promise<StdResponse<any>> {
    return manageAxios.get(`/objects/upload/url`, {
        params: {
            objectName: `${objectName}`,
            ...params,
        }
    })
}

export function getFileUrl(params?: {}): Promise<StdResponse<any>> {
    return manageAxios.get(`/objects/url`, {
        params: {
            ...params,
        }
    })
}